// Making a new JS component
// 1 - Replace header with new name ( 8 occurences in this file )
// 2 - All code goes into init()
// 3 - Save file as new name .js
var header = {
    name: "header",
    componentInitSelector: "header",
    registerComponent: function () {
        if ($(header.componentInitSelector).length) {
            framework.registerComponent(header);
        }
    },
    initHeader: function () {
        // Put your args and inits here with their options.
        // End
        // log(config.application.name + " •• header in " + Math.round( performance.now() - framework.initComponents.componentInitTime) + " milliseconds" );
    },
    init: function () {
        // All code for this component goes in here

        /* Shrink on Scroll */
        if ($(window).width() > 940) {
            $(window).scroll(function () {
                if ($(window).scrollTop() > 200) {
                    $("header .container, header").addClass("is-scrolling");
                }

                if ($(window).scrollTop() < 350) {
                    $("header .container, header").removeClass("is-scrolling");
                }
            });
        }

        /* Attach Homepage Video */

        function attachVideo() {
            var videoWrap = document.querySelector(".hero-banner-inside");

            function createVideoMarkup(item) {
                var videoMarkup =
                    '<div class="hero-banner__videoContainer"><video id="heroVideo" playsinline autoplay muted loop src="' +
                    item +
                    '" type="video/mp4"></video></div>';
                return videoMarkup;
            }

            // fire function only if the video wrap exists
            if (videoWrap) {
                var videoLink = videoWrap.dataset.link;
                videoWrap.innerHTML = createVideoMarkup(videoLink);
            }
        }

        /* Only Fire video on tablet and desktop*/

        if ($(window).width() > 768) {
            /* Delay Loading of Video by 5 Seconds */

            setTimeout(function () {
                /*attach video*/
                attachVideo();
            }, 5000);
        }

        /* Footer Sign Up Form */

        $('#scroll-to-contact-button').click( function() {
            $('.contact-form').removeClass('not-opened');
        });

        function newsletterTogger() {
            var button = document.querySelector(".newsletter .title");
            var signup = document.querySelector(".newsletter-form");
            $(signup).addClass("hidden");

            if (button) {
                button.addEventListener("click", function (e) {
                    $(signup).removeClass("hidden");
                    $(signup).fadeIn();
                });
            }
        }

        newsletterTogger();

        /* Footer Contact Form */

        function contactFormTogger() {
            var container = document.querySelector(".contact-form");
            var button = document.querySelector(".contact-form .col-md-12");
            var signup = document.querySelector(".contact-form iframe");

            if (container) {
                container.classList.add("not-opened");
                container.addEventListener("click", function (e) {
                    container.classList.toggle("not-opened");
                });
            }
        }

        /* Only Trigger on US Website */
        var ussite = document.querySelector(".lang-us-en");
        if (ussite) {
            contactFormTogger();
        }

        /* CN Site We Chat PopUp Function  */

        function weChatCN() {
            var chatIcon = document.querySelector(".social-mobile .wechat a");
            if (chatIcon) {
                wechatPopUp = document.createElement("div");
                wechatPopUp.classList.add("weChatPopUp");
                wechatImage =
                    '<div class="modal" tabindex="-1" role="dialog"> <div class="modal-dialog" role="document"> <div class="modal-content"> <div class="modal-header"> <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </div> <div class="modal-body"> <img src="https://www.teamlewis.cn/wp-content/uploads/2020/05/CN-WeChatQRcode-TeamLEWIS.jpg" width="300"> </div> </div> </div> </div>';
                wechatPopUp.innerHTML = wechatImage;

                chatIcon.addEventListener("click", function (event) {
                    event.preventDefault;
                    console.log(chatIcon);
                    $(wechatPopUp).modal();
                    $(wechatPopUp.firstChild).css("display", "block");
                    $(wechatPopUp.firstChild.firstElementChild).css(
                        "margin-top",
                        "150px"
                    );
                    console.log(wechatPopUp.firstChild.firstElementChild);
                });
            }
        }

        var chinasite = document.querySelector(".alternative-china");
        if (chinasite) {
            weChatCN();
        }

        /* Homepage 2020 Video Play Button */
        function playVideo() {
            playbutton = document.querySelector(".play-home-video");
            if (playbutton) {
                videoPop = document.createElement("div");
                videoPop.classList.add("video-pop");
                videoModal =
                    '<div id="rolesModal" class="modal" role="dialog"> <div class=""> <div class="modal-content"> <button type="button" class="close-home" data-dismiss="modal">&times;</button> <div class="video-container"> <video playsinline="" loop="" autoplay="" controls="0" class="modalclassvideo" src="https://player.vimeo.com/external/372569706.hd.mp4?s=5a4aad33b5d51e95cef53428707d30d18e75e187&profile_id=175"></video> </div> </div> </div> </div>';
                videoPop.innerHTML = videoModal;

                playbutton.addEventListener("click", function () {
                    $(videoPop).modal();
                    $(videoPop.firstChild).css("display", "block");
                    $(videoPop.firstChild.firstElementChild).addClass(
                        "fix-for-video-modal"
                    );
                    $("video").trigger("play");

                    var closeButton = document.querySelector(".close-home");
                    closeButton.addEventListener("click", function () {
                        $("video").trigger("pause");
                    });
                });
            }
        }

        playVideo();

        /* Init Header */

        header.initHeader();
    },
};

// Register self to the framework
header.registerComponent();
